import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Observable, of } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { FormFieldBase } from '@modules/creator/components/forms/form-field/form-field-base';
import { FormService } from '@modules/creator/components/special-block/forms/services/form.service';

@Component({
    selector: '[password-field]',
    styles: [`
    mat-form-field {
      width: 100%;
      font-family: inherit !important;
      font-size: inherit !important;
      line-height: inherit !important;
      letter-spacing: inherit !important;
      font-kerning: inherit !important;
      font-weight: inherit !important;
      text-transform: inherit !important;
      color: inherit !important;
      font-style: inherit !important;
      text-decoration: inherit !important;
      text-shadow: inherit !important;
      text-align: inherit !important;
    }

    mat-form-field label {
      font-family: inherit !important;
      font-size: inherit !important;
      line-height: inherit !important;
      letter-spacing: inherit !important;
      font-kerning: inherit !important;
      font-weight: inherit !important;
      text-transform: inherit !important;
      color: inherit !important;
      font-style: inherit !important;
      text-decoration: inherit !important;
      text-shadow: inherit !important;
      text-align: inherit !important;
    }

    .mat-icon {
      font-family: 'Material Icons';
      font-weight: normal;
      font-style: normal;
      font-size: 24px;
    }
  `],
    template: `
    <div [formGroup]="formGroup">
      <mat-form-field appearance="outline" [class]="item.uId">
        <mat-label>{{ item.content }}</mat-label>
        <input matInput
               [type]="hide ? 'password' : 'text'"
               [formControlName]="formName"
               (keyup)="onKey($event)"
               [attr.aria-label]="item.content || null"
               [tabIndex]="item.tabindex"
               [required]="required"
               autocomplete="current-password"
               (ngModelChange)="dataChanged($event)">
        <button mat-icon-button matSuffix type="button"
                (click)="hide = !hide"
                [attr.aria-label]="'Hide password'"
                [attr.aria-pressed]="hide">
          <mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
        <mat-error *ngIf="invalid">{{ getErrorMessage$() | async | translate }}</mat-error>
      </mat-form-field>
    </div>
  `,
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Default,
    standalone: false
})
export class PasswordFieldComponent extends FormFieldBase implements OnInit {
  hide = true;

  constructor(fs: FormService, private translate: TranslateService) {
    super(fs);
  }

  ngOnInit(): void {
    this.fs.addPasswordControl(this.item.settings);
  }

  getErrorMessage$(): Observable<string> {
    const errors = this.formGroup.get(this.formName);
    let message = super.getErrorMessage$();


    if (errors.hasError('requiredLength')) {
      const requiredLengthError = errors.getError('requiredLength');
      message = this.translate.get('forms.requiredLength',
        {
          requiredLength: requiredLengthError.requiredLength,
          actualLength: requiredLengthError.actualLength
        });

    }

    if (errors.hasError('requireLowercase')) {
      message = of(`forms.requireLowercase`);
    }

    if (errors.hasError('requireUppercase')) {
      message = of(`forms.requireUppercase`);
    }

    if (errors.hasError('requireNonAlphanumeric')) {
      message = of('forms.requireNonAlphanumeric');
    }

    if (errors.hasError('requireDigit')) {
      message = of(`forms.requireDigit`);
    }
    return message;
  }
}
